import {
  API_TYPE,
  currentEnv,
  ENV_VARIABLES,
  warehouseId,
} from "../../constants";
import {
  AdminService_NEW_FDB,
  AdminService_NEW_URL,
  CheckerService_URL,
  CustomerService_NEW_URL,
  PickerService_URL,
  WarehouseMumbaiService_URL,
} from "../Url";
import { makeApiCall } from "../makeApiCall";

export const TOActions = {
  FETCH_TO_PICKER_SUCCESS: "FETCH_TO_PICKER_SUCCESS",
  FETCH_TO_PICKER_FAILURE: "FETCH_TO_PICKER_FAILURE",
  FETCH_TO_BOX_LOGS_SUCCESS: "FETCH_TO_BOX_LOGS_SUCCESS",
  FETCH_TO_BOX_LOGS_FAILURE: "FETCH_TO_BOX_LOGS_FAILURE",
  UPDATE_TO_MED_SUCCESS: "UPDATE_TO_MED_SUCCESS",
  UPDATE_TO_MED_FAILURE: "UPDATE_TO_MED_FAILURE",
  FETCH_TO_BATCHES_SUCCESS: "FETCH_TO_BATCHES_SUCCESS",
  FETCH_TO_BATCHES_FAILURE: "FETCH_TO_BATCHES_FAILURE",
  FETCH_CHECKER_TOID_SUCCESS: "FETCH_CHECKER_TOID_SUCCESS",
  FETCH_CHECKER_TOID_FAILURE: "FETCH_CHECKER_TOID_FAILURE",
  GET_TO_BOXES_SUCCESS: "GET_TO_BOXES_SUCCESS",
  GET_TO_BOXES_FAILURE: "GET_TO_BOXES_FAILURE",
  MARK_MEDISSUE_SUCCESS: "MARK_MEDISSUE_SUCCESS",
  MARK_MEDISSUE_FAILURE: "MARK_MEDISSUE_FAILURE",
  UPDATE_RACK_SUCCESS: "UPDATE_RACK_SUCCESS",
  UPDATE_RACK_FAILURE: "UPDATE_RACK_FAILURE",
  GET_RACK_SUCCESS: "GET_RACK_SUCCESS",
  GET_RACK_FAILURE: "GET_RACK_FAILURE",
  ELASTIC_DATA_SUCCESS: "ELASTIC_DATA_SUCCESS",
  ELASTIC_DATA_FAILURE: "ELASTIC_DATA_FAILURE",
  GET_RACK_LOCATION_SUCCESS: "GET_RACK_LOCATION_SUCCESS",
  GET_RACK_LOCATION_FAILURE: "GET_RACK_LOCATION_FAILURE",
  UPDATE_RACK_LOCATION_SUCCESS: "UPDATE_RACK_LOCATION_SUCCESS",
  UPDATE_RACK_LOCATION_FAILURE: "UPDATE_RACK_LOCATION_FAILURE",
  FETCH_BIN_SUCCESS: "FETCH_BIN_SUCCESS",
  FETCH_BIN_FAILURE: "FETCH_BIN_FAILURE",
  FETCH_TASKID_SUCCESS: "FETCH_TASKID_SUCCESS",
  FETCH_TASKID_FAILURE: "FETCH_TASKID_FAILURE",
  PRODUCTS_YET_TO_FETCH_SUCCESS: "PRODUCTS_YET_TO_FETCH_SUCCESS",
  PRODUCTS_YET_TO_FETCH_FAILURE: "PRODUCTS_YET_TO_FETCH_FAILURE",
  PICKING_DONE_SUCCESS: "PICKING_DONE_SUCCESS",
  PICKING_DONE_FAILURE: "PICKING_DONE_FAILURE",
  FETCH_TASKID_DETAILS_SUCCESS: "FETCH_TASKID_DETAILS_SUCCESS",
  FETCH_TASKID_DETAILS_FAILURE: "FETCH_TASKID_DETAILS_FAILURE",
  FETCH_BIN_DETAILS_SUCCESS: "FETCH_BIN_DETAILS_SUCCESS",
  FETCH_BIN_DETAILS_FAILURE: "FETCH_BIN_DETAILS_FAILURE",
  BIN_PICKING_SUCCESS: "BIN_PICKING_SUCCESS",
  BIN_PICKING_FAILURE: "BIN_PICKING_FAILURE",
};

const POSTMAN_API =
  "https://c79f972d-60b9-49ef-847f-e61d8c015a76.mock.pstmn.io";

// ------------------------- GET TO ORDERS
// -------------------------------------------------------------------

export function getTOPickerOrderSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_TO_PICKER_SUCCESS,
      payload: props,
    });
  };
}

export function getTOPickerOrderError(error) {
  return {
    type: TOActions.FETCH_TO_PICKER_FAILURE,
    payload: error,
  };
}

export function getTOPickerOrderThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${PickerService_URL}/getOrderForPicker${
    props.toNumber ? `?transferOrderId=${props.toNumber}` : ""
  }`;

  // const getUrl = `https://c79f972d-60b9-49ef-847f-e61d8c015a76.mock.pstmn.io/getOrderForPicker${
  //   props.toNumber ? `?toNumber=${props.toNumber}` : ""
  // }`;
  return makeApiCall(
    getUrl,
    getTOPickerOrderSuccess,
    getTOPickerOrderError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- GET MEDBOX LOGS
// -------------------------------------------------------------------

export function getTOBoxLogSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_TO_BOX_LOGS_SUCCESS,
      payload: props,
    });
  };
}

export function getTOBoxLogError(error) {
  return {
    type: TOActions.FETCH_TO_BOX_LOGS_FAILURE,
    payload: error,
  };
}

export function getTOBoxLogThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${PickerService_URL}/getMedsInBox?toNumber=${props.toNumber}`;
  return makeApiCall(
    getUrl,
    getTOBoxLogSuccess,
    getTOBoxLogError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- UPDATE TO PICKER MED
// -------------------------------------------------------------------

export function updateTOMedSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.UPDATE_TO_MED_SUCCESS,
      payload: props,
    });
  };
}

export function updateTOMedError(error) {
  return {
    type: TOActions.UPDATE_TO_MED_FAILURE,
    payload: error,
  };
}

export function updateTOMedThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${PickerService_URL}/saveQuantityInBox?toNumber=${
    props.toNumber
  }${props.boxNumber ? `&boxNumber=${props.boxNumber}` : ""}${
    props.productCode ? `&productCode=${props.productCode}` : ""
  }${props.quantity ? `&quantity=${props.quantity}` : ""}`;
  return makeApiCall(
    postUrl,
    updateTOMedSuccess,
    updateTOMedError,
    "POST",
    null,
    //  props.medData,
    reqHeader,
    props.history,

    API_TYPE.NEW
  );
}

// ------------------------- Picker Med Fetch Batches
// -------------------------------------------------------------------

export function fetchTOBatchesSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_TO_BATCHES_SUCCESS,
      payload: props,
    });
  };
}

export function fetchTOBatchesError(error) {
  return {
    type: TOActions.FETCH_TO_BATCHES_FAILURE,
    payload: error,
  };
}

export function fetchTOBatchesThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  const postUrl = `${
    currentEnv === ENV_VARIABLES.PRODUCTION
      ? WarehouseMumbaiService_URL
      : "https://stage-mum.truemedsapi.in/WarehouseMumbaiService"
  }/itemAvailableStock`;

  return makeApiCall(
    postUrl,
    fetchTOBatchesSuccess,
    fetchTOBatchesError,
    "POST",
    props,
    reqHeader,
    props.history
  );
}

// ------------------------- Checker Fetch API
// -------------------------------------------------------------------

export function fetchCheckerTOSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_CHECKER_TOID_SUCCESS,
      payload: props,
    });
  };
}

export function fetchCheckerTOError(error) {
  return {
    type: TOActions.FETCH_CHECKER_TOID_FAILURE,
    payload: error,
  };
}

export function fetchCheckerTOThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let getUrl = `${CheckerService_URL}/fetchToDetailsForChecker?`;

  let tempUrl = "";

  if (Object.keys(props).length > 0) {
    Object.keys(props).forEach((key) => {
      switch (key) {
        case "boxNumber":
          tempUrl += `&boxNumber=${props.boxNumber}`;
          break;
        case "toNumber":
          tempUrl += `&toNumber=${props.toNumber}`;
          break;
        default:
          break;
      }
    });
  }

  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  getUrl += tempUrl;

  return makeApiCall(
    getUrl,
    fetchCheckerTOSuccess,
    fetchCheckerTOError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Checker Fetch Boxes
// -------------------------------------------------------------------

export function getCheckerTOBoxesSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.GET_TO_BOXES_SUCCESS,
      payload: props,
    });
  };
}

export function getCheckerTOBoxesError(error) {
  return {
    type: TOActions.GET_TO_BOXES_FAILURE,
    payload: error,
  };
}

export function getCheckerTOBoxesThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let getUrl = `${CheckerService_URL}/getBoxStatus?`;

  let tempUrl = "";

  if (Object.keys(props).length > 0) {
    Object.keys(props).forEach((key) => {
      switch (key) {
        case "toNumber":
          tempUrl += `&toNumber=${props.toNumber}`;
          break;
        default:
          break;
      }
    });
  }

  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  getUrl += tempUrl;

  return makeApiCall(
    getUrl,
    getCheckerTOBoxesSuccess,
    getCheckerTOBoxesError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Checker Update Med Call
// -------------------------------------------------------------------

export function markCheckerIssueSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.MARK_MEDISSUE_SUCCESS,
      payload: props,
    });
  };
}

export function markCheckerIssueError(error) {
  return {
    type: TOActions.MARK_MEDISSUE_FAILURE,
    payload: error,
  };
}

export function markCheckerIssueThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let postUrl = `${CheckerService_URL}/markIssueMedicine`;

  return makeApiCall(
    postUrl,
    markCheckerIssueSuccess,
    markCheckerIssueError,
    "POST",
    props.data,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Update status of JIT & BULK locatin
// -------------------------------------------------------------------

export function updateRackStatusSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.UPDATE_RACK_SUCCESS,
      payload: props,
    });
  };
}

export function updateRackStatusError(error) {
  return {
    type: TOActions.UPDATE_RACK_FAILURE,
    payload: error,
  };
}

export function updateRackStatusThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let postUrl = `${PickerService_URL}/disabledRackLocation?warehouseId=${
    props.warehouseId
  }&productCode=${props.productCode}&bothLocationPresent=${
    props.bothLocationPresent
  }&location=${props.location ?? ""}`;

  return makeApiCall(
    postUrl,
    updateRackStatusSuccess,
    updateRackStatusError,
    "POST",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get Rack locations api
// -------------------------------------------------------------------

export function getRackStatusSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.GET_RACK_SUCCESS,
      payload: props,
    });
  };
}

export function getRackStatusError(error) {
  return {
    type: TOActions.GET_RACK_FAILURE,
    payload: error,
  };
}

export function getRackStatusThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let postUrl = `${PickerService_URL}/getMedicineRackLocation?warehouseId=${props.warehouseId}`;

  return makeApiCall(
    postUrl,
    getRackStatusSuccess,
    getRackStatusError,
    "POST",
    props.medData,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Elastic call api
// -------------------------------------------------------------------

export function fetchElasticSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.ELASTIC_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function fetchElasticError(error) {
  return {
    type: TOActions.ELASTIC_DATA_FAILURE,
    payload: error,
  };
}

export function fetchElasticThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  let getUrl = `${CustomerService_NEW_URL}/fetchFromElasticSearch?warehouseId=${props.warehouseId}&isMultiSearch=${props.isMultiSearch}&elasticSearchType=${props.elasticSearchType}&searchString=${props.searchString}`;

  return makeApiCall(
    getUrl,
    fetchElasticSuccess,
    fetchElasticError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.OLD
  );
}

// ------------------------- Get Rack locations api NEW
// -------------------------------------------------------------------

export function getRackLocationsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.GET_RACK_LOCATION_SUCCESS,
      payload: props,
    });
  };
}

export function getRackLocationsError(error) {
  return {
    type: TOActions.GET_RACK_LOCATION_FAILURE,
    payload: error,
  };
}

export function getRackLocationsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  // let postUrl = `https://c79f972d-60b9-49ef-847f-e61d8c015a76.mock.pstmn.io/getPickerMedicineRackLocation?warehouseId=${props.warehouseId}&toId=${props.toId}`;
  let postUrl = `${PickerService_URL}/getPickerMedicineRackLocation?warehouseId=${props.warehouseId}&toId=${props.toId}`;

  return makeApiCall(
    postUrl,
    getRackLocationsSuccess,
    getRackLocationsError,
    "POST",
    props.productCodes,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get Rack locations api NEW
// -------------------------------------------------------------------

export function updateRackLocationSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.UPDATE_RACK_LOCATION_SUCCESS,
      payload: props,
    });
  };
}

export function updateRackLocationError(error) {
  return {
    type: TOActions.UPDATE_RACK_LOCATION_FAILURE,
    payload: error,
  };
}

export function updateRackLocationThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  // let postUrl = `https://c79f972d-60b9-49ef-847f-e61d8c015a76.mock.pstmn.io/updatePickerRackQuantity?warehouseId=${
  //   props.warehouseId
  // }&productCode=${props.productCode}&location=${
  //   props.location
  // }&pickedQuantity=${props.pickedQuantity}&boxNumber=${
  //   props.boxNumber
  // }&batchNumber=${props.batchNumber}${
  //   props.reasonId ? `&reasonId=${props.reasonId}` : ""
  // }`;
  let postUrl = `${PickerService_URL}/updatePickerRackQuantity?warehouseId=${
    props.warehouseId
  }&productCode=${props.productCode}&location=${
    props.location
  }&pickedQuantity=${props.pickedQuantity}&boxNumber=${
    props.boxNumber
  }&batchNumber=${props.batchNumber}${
    props.reasonId ? `&reasonId=${props.reasonId}` : ""
  }&toId=${props.toId}&type=${props.type}`;

  return makeApiCall(
    postUrl,
    updateRackLocationSuccess,
    updateRackLocationError,
    "POST",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get BIN locations api NEW
// -------------------------------------------------------------------

export function fetchBinSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_BIN_SUCCESS,
      payload: props,
    });
  };
}

export function fetchBinError(error) {
  return {
    type: TOActions.FETCH_BIN_FAILURE,
    payload: error,
  };
}

export function fetchBinThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let getUrl = `${POSTMAN_API}/fetchBinMaster?warehouseId=${warehouseId}&binNumber=${props.binNumber}&isPicking=${props.isPicking}&isRacking=${props.isRacking}`;
  let getUrl = `${PickerService_URL}/fetchBinMaster?warehouseId=${warehouseId}&binNumber=${props.binNumber}&isPicking=${props.isPicking}&isRacking=${props.isRacking}&isPutAway=${props.isPutAway}&isScan=${props.isScan}`;

  return makeApiCall(
    getUrl,
    fetchBinSuccess,
    fetchBinError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get task ID of bin transfer user
// -------------------------------------------------------------------

export function getTaskIDSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_TASKID_SUCCESS,
      payload: props,
    });
  };
}

export function getTaskIDError(error) {
  return {
    type: TOActions.FETCH_TASKID_FAILURE,
    payload: error,
  };
}

export function getTaskIDThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let getUrl = `${POSTMAN_API}/fetchTaskDetailId`;
  let getUrl = `${PickerService_URL}/fetchTaskDetailId`;

  return makeApiCall(
    getUrl,
    getTaskIDSuccess,
    getTaskIDError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}
// ------------------------- products Yet To Racked
// -------------------------------------------------------------------

export function productsYetToRackedSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.PRODUCTS_YET_TO_FETCH_SUCCESS,
      payload: props,
    });
  };
}

export function productsYetToRackedError(error) {
  return {
    type: TOActions.PRODUCTS_YET_TO_FETCH_FAILURE,
    payload: error,
  };
}

export function productsYetToRackedThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let getUrl = `${POSTMAN_API}/fetchTaskDetailId`;
  let getUrl = `${PickerService_URL}/productsYetToRacked`;

  return makeApiCall(
    getUrl,
    productsYetToRackedSuccess,
    productsYetToRackedError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get task ID details
// -------------------------------------------------------------------

export function getTaskIDDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_TASKID_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function getTaskIDDetailsError(error) {
  return {
    type: TOActions.FETCH_TASKID_DETAILS_FAILURE,
    payload: error,
  };
}

export function getTaskIDDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let getUrl = `${POSTMAN_API}/fetchPickedProductForTaskId?taskId=${props.taskId}`;
  let getUrl = `${PickerService_URL}/fetchPickedProductForTaskId?taskId=${props.taskId}`;

  return makeApiCall(
    getUrl,
    getTaskIDDetailsSuccess,
    getTaskIDDetailsError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Get Rack Picking API
// -------------------------------------------------------------------

export function fetchBinItemsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.FETCH_BIN_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function fetchBinItemsError(error) {
  return {
    type: TOActions.FETCH_BIN_DETAILS_FAILURE,
    payload: error,
  };
}

export function fetchBinItemsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let getUrl = `${POSTMAN_API}/fetchItemsAvailableInBin?warehouseId=${warehouseId}&binNumber=${props.binNumber}`;
  let getUrl = `${PickerService_URL}/fetchItemsAvailableInBin?warehouseId=${warehouseId}&binNumber=${props.binNumber}`;

  return makeApiCall(
    getUrl,
    fetchBinItemsSuccess,
    fetchBinItemsError,
    "GET",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Picking done api
// -------------------------------------------------------------------

export function pickDoneSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.PICKING_DONE_SUCCESS,
      payload: props,
    });
  };
}

export function pickDoneError(error) {
  return {
    type: TOActions.PICKING_DONE_FAILURE,
    payload: error,
  };
}

export function pickDoneThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let postUrl = `${POSTMAN_API}/markPickingAsComplete?taskId=${props.taskId}`;
  let postUrl = `${PickerService_URL}/markPickingAsComplete?taskId=${props.taskId}`;

  return makeApiCall(
    postUrl,
    pickDoneSuccess,
    pickDoneError,
    "POST",
    null,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}

// ------------------------- Med level picking TO
// -------------------------------------------------------------------

export function binPickingSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: TOActions.BIN_PICKING_SUCCESS,
      payload: props,
    });
  };
}

export function binPickingError(error) {
  return {
    type: TOActions.BIN_PICKING_FAILURE,
    payload: error,
  };
}

export function binPickingThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };

  // let postUrl = `${POSTMAN_API}/addBinPickingDetails?taskId=${props.taskId}`;
  let postUrl = `${PickerService_URL}/addBinPickingDetails?taskId=${props.taskId}`;

  return makeApiCall(
    postUrl,
    binPickingSuccess,
    binPickingError,
    "POST",
    props.medData,
    reqHeader,
    props.history,
    API_TYPE.NEW
  );
}
